import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserCreationPdfComponent } from './core/user-creation-pdf/user-creation-pdf.component';
import { UserDeletionPdfComponent } from './core/user-deletion-pdf/user-deletion-pdf.component';

const routes: Routes = [
	{ path: '', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule) },
	{ path: 'suzuki', loadChildren: () => import('./core/core.module').then(m => m.CoreModule) }
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }
